import { HashLink as Link } from "react-router-hash-link";
import { useDispatch, useSelector } from "react-redux";
import { connectM } from "./redux/blockchain/blockchainActions";
import { fetchDataM } from "./redux/data/dataActions";

import "./styles/navbar.css";
const Navbar = () => {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchDataM(blockchain.account));
    }
  };

  getData();

  return (
    <nav className="nav-wrap">
      <ul>
        <Link className="logo" to="/">
          <img
            src="https://i.ibb.co/qDLRqS5/panda.png"
            width="300"
            height="120"
          />
        </Link>

        <li
          className="stakebox"
          onClick={(e) => {
            e.preventDefault();
            dispatch(connectM());
          }}
        >
          <Link to="/staking">Click</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
